import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';
import { useMutation } from '@apollo/client';
import { promiseModalDialog, toastSuccess } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useHandleError } from 'shared-pages/services';
import { gqlCloseNotification } from '../graphql';

/** Κλείνει την ενημέρωση — μετά δεν δέχεται απαντήσεις από τους συνδέσμους του mail */
export const CloseNotificationButton = ({
  notificationId,
  disabled,
  onClosed,
}: {
  notificationId: number;
  disabled?: boolean;
  onClosed: () => void;
}) => {
  const { t } = useTranslation();
  const { handleGraphqlError } = useHandleError('CloseNotification');
  const [close, { loading }] = useMutation(gqlCloseNotification);

  const handleClose = async () => {
    const confirmed = await promiseModalDialog({
      title: t('Κλείσιμο ενημέρωσης'),
      text: t(
        'Μετά το κλείσιμο οι παραλήπτες δεν θα μπορούν να απαντήσουν από τον σύνδεσμο του mail. Θέλετε να συνεχίσετε;',
      ),
    });
    if (!confirmed) return;

    try {
      const { data } = await close({ variables: { id: notificationId } });
      const result = data?.closeNotification;
      if (!result?.id) throw new Error(t('Αποτυχία κλεισίματος'));
      toastSuccess(t('Η ενημέρωση έκλεισε'));
      onClosed();
    } catch (error) {
      handleGraphqlError('mutation-close', error);
    }
  };

  return (
    <Button
      onClick={handleClose}
      disabled={loading || disabled}
      className="button-animate-scale ms-2"
      type="button"
      size="sm"
      variant="outline-dark"
      title={disabled ? t('Αποθηκεύστε πρώτα τις αλλαγές') : undefined}
    >
      {loading ? (
        <Spinner animation="border" size="sm" className="mb-1" />
      ) : (
        <span className="d-flex align-items-center">
          <FaLock className="me-2 button-icon" />
          {t('Κλείσιμο ενημέρωσης')}
        </span>
      )}
    </Button>
  );
};
